var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('logo-icon',{staticClass:"logo-btn",attrs:{"logoIcon":true}}),_c('Return',{staticClass:"menu-btn",attrs:{"return":true}})],1),_c('h1',[_vm._v("TicTacToe")]),_c('TicTacVue')],1)}
var staticRenderFns = []

export { render, staticRenderFns }